/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * State of the overall job.
 *
 * "Paused" indicates the job search was explicitly paused or stopped.
 * (waiting for a deployment to continue, or will continue to be stopped)
 * "Pending" indicates ongoing state
 * (waiting for user input or currently processing).
 * "Draft" indicates a result was generated and the search has terminated.
 * "ReadyToRun" indicates a result was generated and the post-generation
 * tasks completed successfully and the code is ready to run.
 * "Failed" indicates an unrecoverable terminal state.
 */
export var JobState;
(function (JobState) {
    JobState["PAUSED"] = "paused";
    JobState["PENDING"] = "pending";
    JobState["SUCCESS"] = "success";
    JobState["DRAFT"] = "draft";
    JobState["READY_TO_RUN"] = "ready_to_run";
    JobState["FAILED"] = "failed";
})(JobState || (JobState = {}));
